var RDV = window.RDV || {};

RDV.InteractiveMap = (function InteractiveMapSetup($) {

	var win = $(window),
		viewW = win.width(),
		viewH = win.height(),
		interactiveMapSection = $("#interactive-map"),
		map = $("#rdv-map"),
		mapSummary = interactiveMapSection.find('#summary'),
		mapSummaryText = interactiveMapSection.find('#summarytext'),
		areas = map.find("area"),
		mapMarker = $(".map-marker"),
		//closeSummary = $('.close-summary'),
		mobileMap = $('#mobileMap'),
		counter = 0,
		resizeTimer;

	function init() {

		map.imageMapResize();

		win.on({
			"load": function () {
				//The setting of the points needs a delay because Internet explorer takes longer until getting the coordinates values and it displays it wrongly
				setTimeout(function () {
					areas.each(function () {
						var $this = $(this),
							$thisMarker = mapMarker.clone(true),
							$thisHeader = $this.attr("alt"),
							$thisLink = $this.data("link"),
							$thisURL = $this.data("urlmap"),
							$thisMisc = $this.data("robe"),
							$thisMarkup =  mapSummaryText.find('#' + $this.attr("id")),
							$thisText = $thisMarkup.html(),
							$thisImg = $thisMarkup.data('photo');
						
                        var $headerWithLink = "";
                        if($thisLink == ""){
                          $headerWithLink = $thisHeader;
                        }else{
                          var a = $('<a />');
                          a.attr('href',$thisLink);
                          console.log("LINK:"+$thisLink );
                          a.text($thisHeader);
                          $headerWithLink = a;
                        }
                  
                      	mobileMap.append('<div><h2>'+$headerWithLink+'</h2><img src="'+$thisImg+'"<div><p>'+$thisText+'</p><h3>'+$thisMisc+'</h3><a href="'+$thisURL+'">Shop Product</a></div></div>');
						//Internet explorer order the coordinates in a different way that rest of browser do. So that's why I need to find among the pair the smallest instead of picking it directly
						$thisCoords = $this.attr("coords"),
						$thisTopCoordStart = Math.min(parseFloat($thisCoords.split(",")[3]), parseFloat($thisCoords.split(",")[1])),
						$thisLeftCoordStart = Math.min(parseFloat($thisCoords.split(",")[0]), parseFloat($thisCoords.split(",")[2]));

						$thisMarker.insertBefore($this);
						$thisMarker.css({
								top: $thisTopCoordStart,
								left: $thisLeftCoordStart
							});

						setTimeout(function(){
							$thisMarker.addClass('loading');
						}, 100);

						$thisMarker.on({
							"mouseenter click": function () {
								map.children().removeClass("fn-active");
								$(this).prev().addClass("fn-active");

								//Populate summary box
								mapSummary
									.css({
										top: positioningLimits($thisMarker.position().top - mapSummary.height()),
										left: positioningLimits($thisMarker.position().left - mapSummary.width())
									})
									.find(".img-location")
										.attr('src', $thisImg)
										.on('load', function(){
											$(this).css('opacity', 1);
										})
									.end()
									.find("h2").html($headerWithLink)
									.end()
									.find("p").html($thisText)
									.end()
									.find("h3").html($thisMisc)
									.end()
									.find("div>a").attr('href', $thisURL)
									.end()
									.show();

								if(mapSummary.offset().top < win.scrollTop()){
									$('body,html').animate({
										scrollTop: 0
									}, 800);
								}
							},
							'mouseleave': closeDescription
						})

						counter++
						if(counter === areas.length){
							mapMarker.remove();
							setTimeout(function(){
								map.find(".map-marker").addClass('loaded');
							}, 500);
						}
					});
				}, 1000);

				mapSummary.on({
					'mouseenter': function(){
						$(this)
							.show()
							.find(".img-location").css('opacity', 1);
					},
					'mouseleave': closeDescription
				})

				// closeSummary.on("click", closeDescription);

				$(document).keyup(function(e) {
					if (e.keyCode == 27) {
						closeDescription
					}
				});
			},
			"resize": function () {
				viewW = win.width();
				viewH = win.height();

				map.find(".map-marker").fadeOut(100);
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(reOrderPoints, 350);
			}
		})

		mapMarker.on("click", function () {
			var $this = $(this);

			$this.next("area").trigger("click");
		});
	};
	//end of init

	function positioningLimits(pos){
		var limit = 50;

		return pos < limit ? limit : pos;
	}

	function closeDescription(){
		mapSummary
			.hide()
			.find(".img-location").css('opacity', 0);
		map.children().removeClass("fn-active");
	}

	function reOrderPoints() {
		areas.each(function () {
			var $this = $(this),
				$thisMarker = $this.prev(),
				$thisCoords = $this.attr("coords"),
				$thisTopCoordStart = Math.min(parseFloat($thisCoords.split(",")[3]), parseFloat($thisCoords.split(",")[1])),
				$thisLeftCoordStart = Math.min(parseFloat($thisCoords.split(",")[0]), parseFloat($thisCoords.split(",")[2]));

			$thisMarker.css({
				top: $thisTopCoordStart,
				left: $thisLeftCoordStart
			});
			$thisMarker.fadeIn("slow");
		});
	}

	return {
		init: init
	};

}(jQuery));

jQuery(RDV.InteractiveMap.init);
